export default __webpack_public_path__ + "static/media/(21).d659a93d.jpg";